import script from "./NsocPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NsocPage.vue?vue&type=script&setup=true&lang=js"

import "./NsocPage.vue?vue&type=style&index=0&id=40862043&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40862043"]])

export default __exports__